/**
 * Tests if string is not empty.
 */
export const regexNonEmptyString = /^(?!\s*$).+/;

/**
 * Tests if string is a valid phone number.
 */
export const regexIsPhoneNumber = /^\+?\d+[\d ]*$/;

/**
 * Tests if string is a 5 digits zip code or a string made of 5 digits, followed by hyphen and 4 digits zip code.
 * Accepts zip codes like 11111 and 11111-2222.
 */
export const regexIsZipCode = /^[0-9]{5}(?:-[0-9]{4})?$/;
